import React, { useEffect, useState } from "react";
import { rosterHistory } from "../../services/userServices";
import BackdropComponent from "components/Spinner/Spinner";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AsttButton from "components/AsttButton/AsttButton";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import moment from "moment";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import PropTypes from "prop-types";

import classes from "./RosterHistory.module.css";
import { Box } from "@mui/material";

const RosterHistory = (props) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState("");
  const [order, setOrder] = useState("ASC");

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const historyResponse = await rosterHistory(props.data.classRosterId);

        if (cancelled) return;

        if (historyResponse.status) {
          if (!cancelled) {
            setHistory(historyResponse.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch roster history:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...history].sort((a, b) => {
        if (a[col] === b[col]) return 0;
        else if (a[col] > b[col]) return 1;
        else return -1;
      });
      setHistory(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...history].sort((a, b) => {
        if (a[col] === b[col]) return 0;
        else if (a[col] < b[col]) return 1;
        else return -1;
      });
      setHistory(sorted);
      setOrder("ASC");
    }
  };

  return (
    <>
      {loading && <BackdropComponent />}
      <TableContainer className={classes.container} component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ backgroundColor: "#f2f2f2", width: "25%" }}
                align="center"
                className={"text-center align-center"}
                onClick={() => sorting("Column")}
              >
                <span className="cursor-pointer">Column</span>

                <Box
                  sx={{
                    display: "inline-block",
                  }}
                >
                  <ArrowUpwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />{" "}
                  <ArrowDownwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f2f2f2",
                  maxWidth: "200",
                  overflow: "auto",
                }}
                align="center"
                className={`${classes.valueContainer} text-center align-center`}
                onClick={() => sorting("value")}
              >
                <span className="cursor-pointer"> Value</span>
                <Box sx={{ display: "inline-block" }}>
                  <ArrowUpwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />{" "}
                  <ArrowDownwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />
                </Box>
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "#f2f2f2" }}
                align="center"
                className={"text-center align-center"}
                onClick={() => sorting("ModifiedBy")}
              >
                <span className="cursor-pointer">Modified By</span>

                <Box sx={{ display: "inline-block" }}>
                  <ArrowUpwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />{" "}
                  <ArrowDownwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />
                </Box>
              </TableCell>
              <TableCell
                sx={{ backgroundColor: "#f2f2f2" }}
                align="center"
                className={"text-center align-center"}
                onClick={() => sorting("ModifiedDate")}
              >
                <span className="cursor-pointer">Modified Date</span>
                <Box sx={{ display: "inline-block" }}>
                  <ArrowUpwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />{" "}
                  <ArrowDownwardIcon sx={{ fontSize: 18, color: "#ED6417" }} />
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.length > 0 &&
              history.map((row, i) => {
                const rowKey = `${row.value}-${i}`;
                return (
                  <TableRow key={rowKey}>
                    <TableCell align="center">{row.Column}</TableCell>
                    <TableCell
                      className={classes.valueContainer}
                      align="center"
                    >
                      <p className={classes.valueText}>{row.value}</p>
                    </TableCell>
                    <TableCell align="center">{row.ModifiedBy}</TableCell>
                    <TableCell align="center">
                      {moment
                        .utc(row.ModifiedDate)
                        .format("YYYY-MM-DD hh:mm:ss A")}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <div className={classes.rosterBtnContainer}>
        <AsttButton onClick={props.onClose}>Close</AsttButton>
      </div>
    </>
  );
};

RosterHistory.propTypes = {
  data: PropTypes.any,
  onClose: PropTypes.func,
};

export default RosterHistory;
